import { getDefaultDate, isDefined } from 'helpers/commons';
import { LANGUAGES_LIST, TIME_FORMATS, TRANSLATION_DEFAULTS } from 'helpers/constants';
import { getParameterByName } from 'helpers/commons';
import moment from 'moment-timezone';

export const updateLocalize = async (current, updates, updateNeeded, settingsParams) => {
	const { numbers, booleans } = updates;
	const siteLanguage = getParameterByName('lang');
	if (siteLanguage && (booleans.autotranslation || !isDefined(numbers.lang))) {
		current.localize.language = LANGUAGES_LIST.includes(siteLanguage) ? siteLanguage : 'en';
	} else if (isDefined(numbers.lang))
		current.localize.language = LANGUAGES_LIST[numbers.lang] || 'en';
	// The Platform (Wix), by default locale returns "zh" as default, which misses in both fullcalendar and boom-translations.
	// There is a "zh-cn" language available instead.
	// if (current.localize.language === "zh") current.localize.language = "zh-cn";
	if (current.localize.language === LANGUAGES_LIST[0]) {
		current.translations = TRANSLATION_DEFAULTS;
	} else {
		const { default: translations } = await import(
			/* webpackChunkName: 'languages/[request]/[request]' */ `translations/${current.localize.language}`
		);
		current.translations = translations;
	}
	moment.locale(current.localize.language);
	current.headerButtonsTexts.today =
		settingsParams && settingsParams.todayButtonText
			? settingsParams.todayButtonText
			: current.translations['Today'];

	if (updateNeeded.numbers) {
		if (isDefined(numbers.firstDay)) {
			current.localize.firstDay = numbers.firstDay;
		}
		if (isDefined(numbers.isRTL)) {
			current.localize.isRtl = !!numbers.isRTL;
		}
		if (isDefined(numbers.timeFormat)) {
			current.localize.timeFormat = TIME_FORMATS[numbers.timeFormat];
		} else {
			current.localize.timeFormat =
				current.localize.language === LANGUAGES_LIST[0] ? TIME_FORMATS[0] : TIME_FORMATS[1];
		}
		if (isDefined(numbers.defaultDate)) {
			current.localize.defaultDate = getDefaultDate(
				numbers.defaultDate,
				current.localize.defaultDate
			);
		}
	}

	if (updateNeeded.booleans) {
		if (isDefined(booleans.showTZone)) {
			current.localize.showTimeZone = booleans.showTZone;
			current.timeZoneParams.showTimeZone = booleans.showTZone;
		}
	}
};
